import React from 'react';
import { MessageSquareQuote, TrendingUp } from 'lucide-react';

const UPSELL_EXAMPLES = [
  {
    scenario: 'Customer orders "a gin and tonic"',
    response: '"Of course! May I suggest a lovely Tanqueray with a Fever-Tree Mediterranean tonic? It\'s a beautiful combination. And would you like a single or a double?"',
  },
  {
    scenario: 'Customer orders "a white wine"',
    response: '"Certainly! We have a gorgeous Sauvignon Blanc or a crisp Pinot Grigio today — which sounds good to you? And would you like a standard or large glass?"',
  },
  {
    scenario: 'Customer orders "a pint of lager"',
    response: '"Of course! We also have [craft keg] on tap which is proving really popular — would you like to try that, or would you prefer a classic lager?"',
  },
  {
    scenario: 'Customer orders "a soft drink"',
    response: '"Lovely! We have Fever-Tree mixers, fresh juices and premium soft drinks — can I suggest our [elderflower lemonade]? It\'s really refreshing."',
  },
];

const GREETING_EXAMPLES = [
  { title: 'At the bar', text: '"Hi there! What can I get for you today?" [smile, eye contact]' },
  { title: 'On arrival', text: '"Welcome to The Rattlebone! Great to see you — where would you like to sit? I\'ll be right with you."' },
  { title: 'Phone call', text: '"Good [morning/afternoon/evening], The Rattlebone, [your name] speaking — how can I help you?"' },
  { title: 'Farewell', text: '"Lovely to see you — hope you enjoyed your visit. See you again soon!"' },
];

export default function ServiceExamples() {
  return (
    <div className="my-4 space-y-4">
      {/* Upselling scripts */}
      <div className="border border-border rounded-xl p-4 bg-card">
        <div className="flex items-center gap-2 mb-3">
          <TrendingUp className="w-4 h-4 text-primary" />
          <h3 className="text-sm font-bold text-foreground">Upselling Script Examples</h3>
        </div>
        <div className="space-y-3">
          {UPSELL_EXAMPLES.map((ex, i) => (
            <div key={i} className="border border-border rounded-lg overflow-hidden">
              <div className="bg-muted/40 px-3 py-1.5">
                <p className="text-xs font-medium text-muted-foreground">📍 Scenario: {ex.scenario}</p>
              </div>
              <div className="px-3 py-2.5 bg-primary/5 border-t border-primary/10">
                <p className="text-xs text-foreground leading-relaxed">
                  <span className="font-semibold text-primary">You say: </span>
                  <em>{ex.response}</em>
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3 bg-muted/40 rounded-lg px-3 py-2">
          <p className="text-xs text-muted-foreground">
            💡 <strong>The golden rule:</strong> Always suggest a premium or specific product rather than just confirming the base order. A customer who says "gin and tonic" hasn't decided which gin yet — that's your opportunity!
          </p>
        </div>
      </div>

      {/* Greeting scripts */}
      <div className="border border-border rounded-xl p-4 bg-card">
        <div className="flex items-center gap-2 mb-3">
          <MessageSquareQuote className="w-4 h-4 text-primary" />
          <h3 className="text-sm font-bold text-foreground">Greeting & Service Scripts</h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {GREETING_EXAMPLES.map((ex, i) => (
            <div key={i} className="bg-muted/30 border border-border rounded-lg px-3 py-2.5">
              <p className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider mb-1">{ex.title}</p>
              <p className="text-xs text-foreground leading-relaxed italic">{ex.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
